// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__L6Vrj","buttons":"SendReceipts_buttons__2S2vo","email":"SendReceipts_email__b9vTR","bookApptTitle":"SendReceipts_bookApptTitle__1ntvK"};